export default [
    // 客房
    {
        name: "Rooms 客房",
        value: "daily_month",
        children: [{
            name: "Total Rooms <br/>总房数",
            value: "Total Rooms <br/>总房数",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Total Rooms Available<br/>可售房",
            value: "Total Rooms Available<br/>可售房",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Total Occupied<br/>占用房合计",
            value: "Total Occupied<br/>占用房合计",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Paid Occupancy%<br/>出租率",
            value: "Paid Occupancy%<br/>出租率",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Average RM Rate(RMB)<br/>平均房价（人民币）",
            value: "Average RM Rate(RMB)<br/>平均房价（人民币）",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Revpar<br/>平均每间房收益",
            value: "Revpar<br/>平均每间房收益",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Total Room Revenue<br/>房费合计",
            value: "Total Room Revenue<br/>房费合计",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Total No. Of Guest<br/>住店客人数",
            value: "Total No. Of Guest<br/>住店客人数",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }, {
            name: "Double Occupancy%<br/>双人入住率",
            value: "Double Occupancy%<br/>双人入住率",
            children: [{
                name: "Today 今日实际",
                value: "actual,last"
            }]
        }]
    },
    {
        name: "Food&Beverage 餐饮",
        value: "daily",
        children: [{
            name: "Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",
            value: "Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",
            value: "Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Chinese Restaurant<br/>中餐厅",
            value: "Chinese Restaurant<br/>中餐厅",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Special Restaurant<br/>特色餐厅",
            value: "Special Restaurant<br/>特色餐厅",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Lobby Lounge<br/>大堂酒吧",
            value: "Lobby Lounge<br/>大堂酒吧",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Room Service<br/>送餐服务",
            value: "Room Service<br/>送餐服务",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Banquet<br/>宴会厅",
            value: "Banquet<br/>宴会厅",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Mini Bar<br/>迷你吧",
            value: "Mini Bar<br/>迷你吧",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Executive Club<br/>行政楼层",
            value: "Executive Club<br/>行政楼层",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Other Income<br/>其他收入",
            value: "Other Income<br/>其他收入",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }, {
            name: "Total F&B Revenue<br/>餐饮合计",
            value: "Total F&B Revenue<br/>餐饮合计",
            children: [{
                name: "Actual 实际收入",
                value: "actual,last_actual"
            }, {
                name: "Covers 人数",
                value: "covers,last_covers"
            }, {
                name: "Average Check 人均消费",
                value: "average,last_average"
            }]
        }]
    },
    {
        name: "Other Revenue 其他收入",
        value: "daily_total",
        children: [{
            name: "Total Other Revenue <br/> 其他收入总计",
            value: "Total Other Revenue <br/> 其他收入总计",
            children: [{
                name: "Today 今日实际",
                value: "other_day,other_last"
            }]
        }]
    },
    {
        name: "Daily Revenue 每日总收入",
        value: "total",
        children: [{
            name: "Grand Total<br/>总计",
            value: "Grand Total<br/>总计",
            children: [{
                name: "Today 今日实际",
                value: "rev_day,rev_last"
            }]
        }]
    }
]


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.2/data.js